import { useState } from "react";
import SvgIcon from "../../helpers/SvgIcon";
import { getTodayInfo } from "../../utils/dateAndTime";
import JulianDateConverterModal from "./JulianDateConverterModal";

export default function NavbarDate() {
  const { dayOfYear, formattedDate } = getTodayInfo();
  const [converterOpen, setConverterOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        title="Convertor dată ↔ Julian"
        aria-label="Deschide convertorul Julian"
        aria-haspopup="dialog"
        aria-expanded={converterOpen}
        onClick={() => setConverterOpen(true)}
        className={`group relative inline-flex min-h-[44px] shrink-0 cursor-pointer items-center gap-3 rounded-control border-0 py-1 pl-2 pr-5 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2196f3]/40 sm:pl-4 sm:pr-6 ${
          converterOpen ? "bg-slate-100" : "bg-surface-subtle"
        }`}>
        <SvgIcon
          type="CALENDAR"
          fill="currentColor"
          className="!hidden !h-[20px] !w-[20px] text-muted-dark sm:!block"
        />
        <span className="whitespace-nowrap text-left leading-snug">
          <span className="block text-[10px] font-medium text-slate-500 sm:text-[11px]">
            Ziua {dayOfYear - 1}
          </span>
          <span className="block text-[11px] font-semibold text-slate-700 sm:text-[13px]">
            {formattedDate}
          </span>
        </span>
        <SvgIcon
          type="DATE_CONVERTER"
          fill="currentColor"
          className="!absolute right-1 top-1 !h-[12px] !w-[12px] text-slate-400 transition-colors group-hover:text-[#2196f3]"
        />
      </button>
      {converterOpen && (
        <JulianDateConverterModal onClose={() => setConverterOpen(false)} />
      )}
    </>
  );
}
